<template>
  <v-card class="peachManagement" flat>
		<v-row class="header">
      <v-col class="d-flex align-center justify-center">
      	<div class="peach"></div>
      	桃子
      </v-col>
      <v-col>價格 (TWD)</v-col>
      <v-col>桃子上限</v-col>
      <v-col>僅限首充</v-col>
      <v-col></v-col>
    </v-row>
    <template v-for="(item, i) in peachList">
			<v-row class="text-center">
				<template v-if="!item.editing">
	  	 		<v-col class="my-auto">{{ item.peaches }}</v-col>
	    		<v-col class="my-auto">{{ item.price_twd }}</v-col>
        </template>
        <template v-else>
          <v-col class="my-auto">
            <v-text-field dense outlined hide-details v-model="item.peaches" :rules="[$rules.integer]"></v-text-field>
          </v-col>
          <v-col class="my-auto">
            <v-text-field dense outlined hide-details v-model="item.price_twd" :rules="[$rules.integer]"></v-text-field>
          </v-col>
        </template>
        <v-col class="my-auto red--text">{{ Math.ceil(item.price_twd * $EXCHANGE_RATE * 0.971125) }}</v-col>
        <v-col class="d-flex justify-center align-center">
          <v-checkbox hide-details v-model="item.first_reverse" @change="submit(item)"></v-checkbox>
        </v-col>
	    	
	    	<v-col>
          <v-btn icon color="indigo" class="mx-1" @click="moveUp(i, item)">
            <v-icon>fa-arrow-up</v-icon>
          </v-btn>
          <v-btn icon color="red" class="mx-1" @click="moveDown(i, item)">
            <v-icon>fa-arrow-down</v-icon>
          </v-btn>
    		  <v-btn icon color="indigo" class="mx-1" v-if="!item.editing" @click="item.editing = true">
	          <v-icon>fa-edit</v-icon>
	        </v-btn>
          <v-btn icon color="green" class="mx-1" v-else @click="save(i)">
            <v-icon>fa-save</v-icon>
          </v-btn>
	        <DeleteConfirmBtn icon color="red" btnClass="mx-1" @delete="deleteItem(i, item)">
	          <v-icon>fa-trash-alt</v-icon>
	        </DeleteConfirmBtn>
	    	</v-col>
	    </v-row>
	    <v-divider class="my-3"></v-divider>
    </template>
    <v-btn block class="pink mt-6" @click="addPeachList">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
export default {
  components: { DeleteConfirmBtn },
  data() {
		return {
			peachList: [],
		}
  },
  created() {
    this.getPeachList()
  },
  methods: {
  	getPeachList() {
  		this.axios.get('/peach/list').then(response => {
  			this.peachList = response.data.data.map(item => {
  				item.editing = false
  				return item
  			})
  		})
  	},
  	deleteItem(i, item) {
  	 this.peachList.splice(i, 1)
     this.submit(item)
  	},
    addPeachList() {
      let list = {peaches: '', price_twd: '', first_reverse: false, editing: true}
      this.peachList.push(list)
    },
    moveUp(i, item) {
      if(i == 0) {
        return
      }
      this.peachList[i] = this.peachList.splice(i - 1, 1, this.peachList[i])[0]
      this.submit(item)
    },
    moveDown(i, item) {
      if(i == this.peachList.length -1) {
        return
      }
      this.peachList[i] = this.peachList.splice(i + 1, 1, this.peachList[i])[0]
      this.submit(item)
    },
    save(i) {
      if(this.$rules.integer(this.peachList[i].peaches) && this.$rules.integer(this.peachList[i].price_twd)) {
        this.peachList[i].editing = false
        this.submit()
      }
    },
    submit(item) {
      if(item && item.editing) {
        return
      }
      this.axios.post('/admin/peach/list', {
        data: this.peachList.filter(item => item.editing == false)
      }).then(response => {
        this.$root.$emit('alert', 'success', '更新成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '更新失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.peachManagement {
  padding: 40px;
  .header {
    color: #999999;
    background: #f6f6f6;
    padding: 0;
    text-align: center;
    font-size: 14px;
  }
  .v-input-checkbox {
    margin: 0;
  }
}
</style>